import { PRODUCT as SG_DATALAYER } from '../datalayer/data/donation.js';

// Product is an object that contains only the following attributes:
// * id
// * title
// * price
// * variants
export function update_datalayer(product, category, ispromo, img_url) {
    // Tealium Data Layer for impression on donation products.
    SG_DATALAYER.category.push(category);
    SG_DATALAYER.id.push(product.id);
    SG_DATALAYER.name.push(product.title);
    SG_DATALAYER.list_position.push('1');
    SG_DATALAYER.list_name.push('General Donation');
    SG_DATALAYER.price.push(product.price);

    if (ispromo === 'true') {
        SG_DATALAYER.promo_id.push(ispromo);
        SG_DATALAYER.promo_name.push(product.title);
        SG_DATALAYER.promo_creative.push(img_url);
        SG_DATALAYER.promo_position.push('1');
    } else {
        SG_DATALAYER.promo_id.push('');
        SG_DATALAYER.promo_name.push('');
        SG_DATALAYER.promo_creative.push('');
        SG_DATALAYER.promo_position.push('');
    }

    // These are not added to utag_data
    SG_DATALAYER.sku.push(product.id);
    SG_DATALAYER.list_variant.push(product.variants);
}
